import Document from "./views/Document";

export default Document;
